module.exports = __webpack_public_path__ + "img/8E907C_B1B5A7_D7DBD0_CCCFBA-256px.1db8f636.png";